import { Navigate, Route, Routes } from "react-router-dom";
import loadable from "@loadable/component";
import { STORAGE_KEYS, storage } from "utils";

const AppRouter = loadable(() => import("./app-router"));
const AuthRouter = loadable(() => import("./auth-router"));

export const Router = () => {
  const hasToken = !!storage.read<string>(STORAGE_KEYS.TOKEN);

  return (
    <>
      <Routes>
        <Route
          path="auth/*"
          element={!hasToken ? <AuthRouter /> : <Navigate to={"/"} replace />}
        />
        <Route
          path="/*"
          element={hasToken ? <AppRouter /> : <Navigate to={"auth"} replace />}
        />
      </Routes>
    </>
  );
};
